import { IconProps } from "../../utils/global-types/global-types";

const ChevronRightIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1393_28282)">
        <path
          fill="currentColor"
          d="M11.257 8.411 7.923 5.078a.833.833 0 0 0-1.178 1.178L9.49 9l-2.744 2.744a.833.833 0 0 0 1.178 1.179l3.334-3.334a.833.833 0 0 0 0-1.178"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1393_28282">
          <path fill="#fff" d="M4 4h10v10H4z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronRightIcon;
